
import React, { Component } from 'react';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { CircularProgress } from '@material-ui/core';

import styled from 'styled-components';
import TableListSort from 'core/TableListSort';
import { DateTimeDisplay, SequenceDisplay } from 'core/Display';
import CopyAsyncItemsFieldToClipboardButton from "../../common/CopyAsyncItemsFieldToClipboardButton";
import {Checkbox2} from "form/Checkbox";


const StyledTableRow = styled(TableRow)`
  background: rgba(0, 0, 0, 0.04);
`;


export class OrderFullTable extends Component {
  render() {
    const { items, onDetail, context } = this.props;

    return (
      <React.Fragment>
        <TableHead>
          <TableRow>
            <TableCell component="th" scope="row" style={{padding: '16px 2px'}}>
              <Checkbox2
                value={context.isSelectedAllItems()}
                onChange={(e) => context.selectAllItems(e.target.checked)}
                size={'small'}
              />
            </TableCell>
            <TableCell component="th" scope="row">
              <TableListSort label={'Дата, №'} name={'date_start'} />
            </TableCell>
            <TableCell component="th" scope="row">Клиент</TableCell>
            <TableCell component="th" scope="row">Перевозчик</TableCell>
            <TableCell component="th" scope="row">Тариф</TableCell>
            <TableCell component="th" scope="row">Откуда/Куда</TableCell>
            <TableCell component="th" scope="row">
              <CopyAsyncItemsFieldToClipboardButton url={`${context.url}/field_container/?${context.getUrlFilter()}`} fieldName={'container_number'}>
                <span>Контейнер</span>
              </CopyAsyncItemsFieldToClipboardButton>
            </TableCell>
            <TableCell component="th" scope="row">Статус/Оплата</TableCell>
            <TableCell component="th" scope="row">Связка</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {context.loading && (
          <StyledTableRow>
            <TableCell colSpan={9}>
              <CircularProgress />
            </TableCell>
          </StyledTableRow>
        )}
        {items.map(item =>
          <TableRow
            key={item.id}
            hover={true}
            className={'pointer'}
            onClick={() => onDetail(item)}
            selected={context.isItemSelected(item)}
          >
            <TableCell onClick={(e) => e.stopPropagation()} style={{padding: '16px 2px'}}>
              <Checkbox2
                value={context.isItemSelected(item)}
                onChange={() => context.toggleSelectItem(item)}
                size={'small'}
              />
            </TableCell>
            <TableCell>
              {item.date_start && <div  className={'mb-3'}><DateTimeDisplay value={item.date_start}  /></div>}
              <div>№{item.id}</div>
            </TableCell>
            <TableCell className={'white-space-pre'}>
              <SequenceDisplay values={[
                item.client ? item.client.name : undefined,
                item.counterparty ? item.counterparty.name : undefined
              ]} separator={'\n'} />
            </TableCell>
            <TableCell>
              {item.carrier && item.carrier.name}
            </TableCell>
            <TableCell>
              {item.tariff_display}
            </TableCell>
            <TableCell>
              {item.points.map(point =>
                <div key={point.id}>{point.point_display}</div>
              )}
            </TableCell>
            <TableCell className={'white-space-pre'}>
              {item.container_number}
            </TableCell>
            <TableCell>
              <div className={'mb-3'}>{item.order_status && item.order_status.label}</div>
              <div>{item.order_payment_status && item.order_payment_status.label}</div>
            </TableCell>
            <TableCell className={'white-space-pre'}>
              <SequenceDisplay values={[
                item.tractor_unit_display,
                item.driver_display,
                item.semi_trailer_display
              ]} separator={'\n'} />
            </TableCell>
          </TableRow>
        )}
        </TableBody>
      </React.Fragment>
    )
  }
}
